import dynamic, { DynamicOptions } from 'next/dynamic'
import { PlaceholderLandscapeCollection } from '@/organisms/PlaceholderLandscapeCollection'
import { WatchNowCollectionProps } from '@/organisms/WatchNowCollection/WatchNowCollection'
import { logger } from '@/utils/logging'

export const WatchNowCollection = dynamic(
  import('./WatchNowCollection')
    .then((mod) => mod.WatchNowCollection)
    .catch((err) =>
      logger().error(`Failed to load the WatchNowCollection!`, err),
    ) as DynamicOptions<WatchNowCollectionProps>,
  { ssr: false, loading: () => <PlaceholderLandscapeCollection /> },
)
